export const environment = {
  production: true,  
  environment: 'production',
  api: {
    baseUrl: 'https://api.intobee.com'
  },
};